import { Text } from 'blaze-ui/Text/Text'
import Styles from './ThreeDotMenuDrawer.module.scss'
import { HelpCenterIcon, Logout1 } from 'blaze-ui/icons'
import { UsersProfiles1 } from 'blaze-ui/icons'
import { Drawer } from 'components/Drawer'
import { DrawerProps } from 'components/Drawer/Root'
import { Pressable } from '@react-aria/interactions'
import useOpenWindowSafely from 'hooks/useOpenWindowSafely'
import { HELP_CENTER_URL } from 'utils/constants'
import { useSession } from 'hooks/useSession'
import { useHistory } from 'react-router-dom'
import { LOGIN_PATH, SELECT_WORKSPACE_PATH } from 'paths'
import { useRootStore } from 'stores/RootStore'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { sendMessageToNativeApp } from 'utils/sendMessageToNativeApp'

export const ThreeDotMenuDrawer = (props: DrawerProps) => {
  const openWindowSafely = useOpenWindowSafely()
  const { logout } = useSession()
  const history = useHistory()
  const { drawersStore } = useRootStore()
  const { isIOSNative } = useResponsiveDesign()

  const navigateToHelpCenter = () => {
    openWindowSafely(HELP_CENTER_URL)
  }

  const handleLogout = () => {
    drawersStore.closeDrawer()

    if (isIOSNative) {
      sendMessageToNativeApp('didSignOut')
      return
    }

    logout({ logoutRedirect: null })

    history.push(LOGIN_PATH)
  }

  const handleSwitchWorkspace = () => {
    drawersStore.closeDrawer()
    history.push(SELECT_WORKSPACE_PATH)
  }

  return (
    <Drawer.Root {...props} handleOnly={true}>
      <Drawer.Portal>
        <Drawer.Overlay withBlur={false} />
        <Drawer.Content>
          <Drawer.InnerContent>
            <Drawer.Top>
              <div />
              <div />
              <Drawer.Close label="Close" variant="ghost" position="right" />
            </Drawer.Top>
            <div className={Styles.content}>
              <Pressable onPress={handleSwitchWorkspace}>
                <div className={Styles.item}>
                  <UsersProfiles1 />
                  <Text>Switch Workspace</Text>
                </div>
              </Pressable>
              <Pressable onPress={navigateToHelpCenter}>
                <div className={Styles.item}>
                  <HelpCenterIcon />
                  <Text>Help Center</Text>
                </div>
              </Pressable>
              <Pressable onPress={handleLogout}>
                <div className={Styles.item}>
                  <Logout1 />
                  <Text>Sign Out</Text>
                </div>
              </Pressable>
            </div>
          </Drawer.InnerContent>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  )
}
